import { Material, UIRenderer } from 'cc';

const originFunc = (UIRenderer.prototype as any)._onMaterialModified;
(UIRenderer.prototype as any)._onMaterialModified = function _onMaterialModified(this: UIRenderer, idx: number, material: Material) {
    originFunc.call(this, idx, material);
    this.node.emit('onMaterialModified', idx, material);
};
